import { render, staticRenderFns } from "./roadmap-stage-task-form.vue?vue&type=template&id=9b4478a0"
import script from "./roadmap-stage-task-form.vue?vue&type=script&lang=js"
export * from "./roadmap-stage-task-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports